import React from "react";

const BusinessAccountIcon = () => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_934_23107)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.048 7.43629C17.619 7.84226 17.9996 8.55677 17.9996 9.36466V11.561C17.9996 11.9791 17.6933 12.3222 17.3199 12.3222H13.9649V9.95332C13.9649 9.33218 13.8199 8.74352 13.568 8.23199C13.5589 8.2117 13.5481 8.1914 13.5372 8.17313C13.916 8.33552 14.3256 8.4228 14.7552 8.4228C15.6361 8.4228 16.439 8.04931 17.0462 7.43832M14.757 2.0957C15.9877 2.0957 16.9828 3.21213 16.9828 4.58838C16.9828 5.96463 15.9859 7.08106 14.757 7.08106C13.5281 7.08106 12.5312 5.96463 12.5312 4.58838C12.5312 3.21213 13.5281 2.0957 14.757 2.0957Z"
          fill="#303544"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.03283 12.3222H0.67969C0.306314 12.3222 0 11.9791 0 11.561V9.36466C0 8.55474 0.380626 7.84226 0.951566 7.43629C1.55876 8.04931 2.3617 8.42077 3.24257 8.42077C3.67214 8.42077 4.08176 8.33349 4.46058 8.1711C4.4497 8.1914 4.44064 8.20967 4.43158 8.22996C4.17783 8.74149 4.03464 9.33015 4.03464 9.95129V12.3201L4.03283 12.3222ZM3.24257 2.0957C4.47145 2.0957 5.46833 3.21213 5.46833 4.58838C5.46833 5.96463 4.47145 7.08106 3.24257 7.08106C2.01369 7.08106 1.01682 5.96463 1.01682 4.58838C1.01682 3.21213 2.01369 2.0957 3.24257 2.0957Z"
          fill="#303544"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1368 7.31158C12.918 7.86574 13.44 8.84616 13.44 9.95244V12.9587C13.44 13.5311 13.0213 14 12.5102 14H5.49036C4.97924 14 4.56055 13.5311 4.56055 12.9587V9.95244C4.56055 8.84414 5.08255 7.86574 5.86374 7.31158C6.69387 8.14992 7.79406 8.66145 8.99938 8.66145C10.2047 8.66145 11.3049 8.15195 12.135 7.31158M9.00119 0C10.685 0 12.0498 1.52849 12.0498 3.41424C12.0498 5.29999 10.685 6.82848 9.00119 6.82848C7.31737 6.82848 5.95255 5.29999 5.95255 3.41424C5.95255 1.52849 7.31737 0 9.00119 0Z"
          fill="#303544"
        />
      </g>
      <defs>
        <clipPath id="clip0_934_23107">
          <rect width="18" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BusinessAccountIcon;
